export const recommendedProductsStyles = {
  root: 'w-full',
  empty: 'py-8 text-center font-sans text-md text-brand-700',
} as const;
